import { useTranslation } from 'react-i18next';
import type { ProcessingStatus } from '@/api/types/event.types';

const STATUS_STYLES: Record<ProcessingStatus, string> = {
  draft: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  uploading: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  processing: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  completed: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  failed: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
};

interface EventStatusBadgeProps {
  status: ProcessingStatus;
  className?: string;
}

export function EventStatusBadge({ status, className = '' }: EventStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status]} ${className}`}
    >
      {status === 'processing' && (
        <span className="me-1.5 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-amber-500" />
      )}
      {status === 'uploading' && (
        <span className="me-1.5 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-blue-500" />
      )}
      {t(`events.status.${status}`)}
    </span>
  );
}
